export default function byteConversion(bytes) {
    const KB = 1024;
    const MB = Math.pow(1024, 2);
    const GB = Math.pow(1024, 3);

    if(bytes < KB) return bytes + " Bytes";
    else if (bytes < MB) return (bytes / KB).toFixed(0) + " KB";
    else if (bytes < GB) return (bytes / MB).toFixed(0) + " MB";
    else return (bytes / GB).toFixed(0) + " GB";
}